export default __webpack_public_path__ + "static/media/GSB.8f15a937.png";